export const API_URL = import.meta.env.VITE_API_URL as string;
export const HUB_URL = import.meta.env.VITE_HUB_URL as string;
export const CONFIGURATION_URL = import.meta.env.VITE_CONFIGURATION_URL as string;
export const ENV = import.meta.env.MODE as string;
